import React, { useState } from 'react'
import { FieldBox } from '../../common/formParts/FieldPartsStyled'
import ScheduleType from './ScheduleType'

const EasyNewsForm = (props) => {
  const [type, setType] = useState(props.easy_news.occurence_datetime_type || 'none')
  const handleChangeScheduleType = (e) => {
    setType(e.target.value)
  }

  return (
    <>
    <FieldBox>
      <input
        type="radio"
        name="easy_news['occurence_datetime_type']"
        id="schedule_type_0"
        value="day_time"
        onChange={handleChangeScheduleType}
        checked={type == 'day_time' || false}
      />
      <label htmlFor="schedule_type_0">日付・時刻</label>

      <input
        type="radio"
        name="easy_news['occurence_datetime_type']"
        id="schedule_type_1"
        value="day_time_range"
        onChange={handleChangeScheduleType}
        checked={type == 'day_time_range' || false}
      />
      <label htmlFor="schedule_type_1">日付・時間帯 (00:00 ~ 00:00)</label>

      <input
        type="radio"
        name="easy_news['occurence_datetime_type']"
        id="schedule_type_2"
        value="day_range"
        onChange={handleChangeScheduleType}
        checked={type == 'day_range' || false}
      />
      <label htmlFor="schedule_type_2">期間 (24/1/1 09:00 ~ 24/1/2 10:00)</label>

      <input
        type="radio"
        name="easy_news['occurence_datetime_type']"
        id="schedule_type_3"
        value="none"
        onChange={handleChangeScheduleType}
        checked={type == 'none' || false}
      />
      <label htmlFor="schedule_type_3">設定なし</label>
    </FieldBox>
    <FieldBox>
      <ScheduleType {...props} dateTimeType={type}/>
    </FieldBox>
    </>
  )
}

export default EasyNewsForm
